export const buildResourceAriaLabel = ({
  type,
  title,
  tags,
}: {
  type: string;
  title: string | null | undefined;
  tags: string[];
}): string => [type, ...(title ? [title] : []), ...tags].join(', ');
